export default __webpack_public_path__ + "static/media/pie-chart.5d810579.svg";